import React, { useState, useEffect } from "react";
import { Languages } from "lucide-react";

export default function FloatingTranslator() {
  const [showLanguages, setShowLanguages] = useState(false);

  const languages = [
    { code: "en", name: "English" },
    { code: "fr", name: "French" },
  ];

  useEffect(() => {
    if (typeof window !== "undefined") {
      const url = window.location.href;
      const isTranslated = url.includes("_x_tr_sl") || url.includes("translate.google.com");
      if (!isTranslated) {
        const baseUrl = url.split("?")[0];
        window.location.href = `https://translate.google.com/translate?sl=en&tl=fr&u=${baseUrl}`;
      }
    }
  }, []);

  const handleLanguageSelect = (langCode) => {
    const baseUrl = window.location.href.split("?")[0];
    window.location.href = `https://translate.google.com/translate?sl=en&tl=${langCode}&u=${baseUrl}`;
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div
        className="flex items-center bg-blue-600 text-white px-4 py-2 rounded-full shadow-lg cursor-pointer hover:bg-blue-700 transition"
        onClick={() => setShowLanguages(!showLanguages)}
      >
        <Languages className="w-5 h-5 mr-2" />
        <span>Translate</span>
      </div>

      {showLanguages && (
        <div className="mt-2 bg-white shadow-lg rounded-xl p-2 max-h-60 overflow-y-auto">
          {languages.map((lang) => (
            <div
              key={lang.code}
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer rounded-md"
              onClick={() => handleLanguageSelect(lang.code)}
            >
              {lang.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
